import styled from 'astroturf';
import { useTheme } from './ThemeContext';
const Anchor = /*#__PURE__*/styled('a', {
  allowAs: false
}, {
  displayName: "Anchor",
  styles: require("./Anchor.module.scss"),
  attrs: props => ({ ...props,
    theme: useTheme(props.theme)
  }),
  vars: []
});
export default Anchor;